import type { MouseEventHandler } from 'react';
import React, { Component } from 'react';

export type PreventClickOnDragProps = {
  children: React.ReactElement;
  onClick?: MouseEventHandler;
  clickTolerance: number;
};

class PreventClickOnDrag extends Component<PreventClickOnDragProps> {
  originClickX: number | null = null;
  cancelClick: boolean = false;

  handleMouseDown = (evt: React.MouseEvent) => {
    this.originClickX = evt.clientX;
  };

  handleMouseUp = (evt: React.MouseEvent) => {
    const x = this.originClickX;
    if (x !== null && Math.abs(x - evt.clientX) > this.props.clickTolerance) {
      this.cancelClick = true;
    }
  };

  handleClick = (evt: React.MouseEvent) => {
    if (!this.cancelClick) {
      this.props.onClick?.(evt);
    }

    this.cancelClick = false;
    this.originClickX = null;
  };

  render() {
    const childElement = React.Children.only(this.props.children);
    return React.cloneElement(childElement, {
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      onClick: this.handleClick,
    });
  }
}

export default PreventClickOnDrag;
